module.exports = __webpack_public_path__ + "img/mario-galaxy-render-8.4b58011b.png";